import { memo } from 'react';

import { AnnotationComment } from '~/components/AnnotationsV2/AnnotationsAvatarsContainer/AnnotationAvatarContainer/components/AnnotationComment';
import { type AnnotationCommentDisplayProps } from '~/components/AnnotationsV2/AnnotationsAvatarsContainer/shared/annotationCommentTypes';
import { usePublicDeleteCommentClick } from '~/swr-hooks/discussions/usePublicDeleteCommentClick';

/**
 * The public asset modals' floating annotation comment — binds the share-link comment delete
 * around the shared comment body. The Public* visualizer wrappers supply it to the annotations
 * tree's AnnotationComment prop.
 */
export const PublicAnnotationComment = memo((props: AnnotationCommentDisplayProps) => {
  const { handleCommentDeleteClick } = usePublicDeleteCommentClick({ trackLocation: 'asset-page' });

  return <AnnotationComment {...props} onDeleteComment={handleCommentDeleteClick} />;
});

PublicAnnotationComment.displayName = 'PublicAnnotationComment';
